module.exports = __webpack_public_path__ + "static/img/Barrio.8ea18ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/Barrio.jpg
// module id = dfIs
// module chunks = 1